import TopBar from './TopBar';
export default function Layout({ children }) {
  return (
    <div style={{ minHeight:'100vh', background:'#fff', fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <TopBar />
      <main style={{ padding:'20px 14px', maxWidth:1400, margin:'0 auto' }}>{children}</main>
    </div>
  );
}
